import {type RunsLinePlotConfig} from '../../../../PanelRunsLinePlot/types';
import {
  getCascadingSetting,
  resolveNullableCascade,
} from '../../getCascadingSetting';
import {type LinePlotSettings} from '../../types';

export const getCascadingYAxisSettings = (
  parentSettings: LinePlotSettings | undefined,
  childSettings?: LinePlotSettings,
  panelSettings?: RunsLinePlotConfig
): {
  yAxisMin: number | undefined;
  yAxisMax: number | undefined;
  yLogScale: boolean | undefined;
} => {
  return {
    yAxisMin: resolveNullableCascade(
      parentSettings?.yAxisMin,
      childSettings?.yAxisMin,
      panelSettings?.yAxisMin
    ),
    yAxisMax: resolveNullableCascade(
      parentSettings?.yAxisMax,
      childSettings?.yAxisMax,
      panelSettings?.yAxisMax
    ),
    yLogScale: getCascadingSetting([
      parentSettings?.yLogScale,
      childSettings?.yLogScale,
      panelSettings?.yLogScale,
    ]),
  };
};
